import { environment } from './../assets/environment/environment';

export const patietManagementUrl = `${environment.apiUrl}patient-management`;
export const caseManagementUrl = `${environment.apiUrl}case-management`;
export const userManagementUrl = `${environment.apiUrl}user-management`;
export const supplierManagementUrl = `${environment.apiUrl}supplier-management`;
export const pharmacyManagementUrl = `${environment.apiUrl}pharmacy-management`;
export const utilityManagementUrl = `${environment.apiUrl}utility-management`;

// Web Api
export const IdentityForgotPassword = `identity/forgotPassword`;
export const IdentityResetPassword = `identity/resetPassword`;

// LabAnalysis constants
export const LabAnalysisCategories = `lab-analysis-categories`;
export const LabAnalysisLookup = `lab-analyses`;

// x-ray constants
export const xRayCategories = `radiology-categories`;
export const xRayLookup = `radiologies`;

// Symptoms constants
export const SymptomsCategories = `symptom-categories`;
export const SymptomsLookup = `symptoms`;

// Disease constants
export const DiseaseCategories = `disease-categories`;
export const DiseaseLookup = `diseases`;

// Surgery constants
export const SurgeryCategories = `surgery-categories`;
export const SurgeryLookup = `surgeries`;

//Patient Profile ---------
export const patientProfiles = `patient-profiles`;
export const labVisits = `lab-visits`;
export const labAnalysis = `lab-analysis`;
export const xRayVisits = `radiology-visits`;
export const xRays = `radiologies`;
export const investForms = `investigation-forms`;
export const AdmissionLookup = `patient-admissions`;
export const hospitalUnits = `hospital-units`;



// Allergy Constants
export const allergyCategories = `alelrgy-categories`;
export const allergyLookup = `allergies`;

// Addiction Constants
export const addictionCategories = `addiction-categories`;
export const addictionLookup = `addictions`;

//User Management ---------
export const backOfficeProfiles = `backoffice-profiles`;
export const createUpdateUser = `${environment.apiUrl}user-management/backoffice-users`;

//Roles ---------
export const backofficeRoles = `backoffice-roles`;
export const createUpdateRoles = `${environment.apiUrl}user-management/backoffice-roles`;

//Scopes ---------
export const Scopes = `scopes`;

//Users ---------
export const Users = `users`;

//Accounts ---------
export const Accounts = `accounts`;

//SystemRoles ---------
export const SystemRoles = `system-roles`;

//SystemRoles ---------
export const SpecializedRoles = `specialized-roles`;

// pharmacyUsers
export const PharmacyUsers = `pharmacy-users`;

// Case details ----------
export const symptomsCategories = `symptom-categories`;
export const symptoms = `symptoms`;
export const drugs = `drugs`;
export const createSymptom = `${environment.apiUrl}patient-management/patient-symptoms`
export const editCase = `${environment.apiUrl}case-management/cases/`
export const attachment = `${utilityManagementUrl}/attachments/`


// Case Recommendation ----------

export const recommendations = `recommendations`;
export const doctorVisit = `doctor-visits`;
export const hospitalVisit = `hospital-visits`;
export const labVisit = `lab-visits`;
export const xrayVisit = `radiology-visits`;
export const medications = `medications`;
export const instructions = `instructions`;
export const doctors = `doctors`;



// Case list ----------
export const cases = `cases`;
export const Pick = `pick`;
export const startCall = `start-call`;
export const endCall = `end-call`;


// Lab Center Constants
export const LabCenterLookup = `lab-analysis-centers`;
export const xRayCenterLookup = `radiology-centers`;
export const hospitalsLookup = `hospitals`;
export const hospitalUnitsLookup = `hospital-units`;
export const doctorsLookup = `doctors`;

// export const caseManagementUrl = `${environment.apiUrl}case-management`;
// export const BackOfficeUrl = `${environment.apiUrl}backoffice`;

export const RecommendationMedication = `recommendations/medications`;
